import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionCtl } from '../services/session.ctl.service';

@Injectable({
  providedIn: 'root',
})
export class SessionEventsService {
  /** Observable para la saber si esta con sesión iniciada */
  private oLoggedInCheck: BehaviorSubject<{ isLoggedIn: boolean; trace: string }>;

  constructor(private sessionCtl: SessionCtl) {
    this.oLoggedInCheck = new BehaviorSubject<{ isLoggedIn: boolean; trace: string }>({
      isLoggedIn: this.sessionCtl.loggedInCheckSync(),
      trace: 'session-events-init',
    });
  }

  loggedInCheck(): Observable<{ isLoggedIn: boolean; trace: string }> {
    return this.oLoggedInCheck;
  }

  /**
   * notificamos a todos los suscriptores
   */
  loggedInCheckPublish(trace: string) {
    this.oLoggedInCheck.next({ isLoggedIn: this.sessionCtl.loggedInCheckSync(), trace });
  }
}